<div class="scale" [style.width]="(hours.length * 60 * unit + 1)+ 'px'">
    <sc-flex stretchContent fitHeight>
        <ng-container *ngFor="let hour of hours">
            <div class="spacer-line"></div>
            <div class="label" [style.min-width]="((60 * unit) -1) + 'px'">
                <sc-padding [half]="true">
                    {{hour}}:00
                </sc-padding>
            </div>
        </ng-container>
        <div class="spacer-line"></div>
    </sc-flex>
</div>
